import { render, staticRenderFns } from "./EditInsuranceCompany.vue?vue&type=template&id=67579796"
import script from "./EditInsuranceCompany.vue?vue&type=script&lang=js"
export * from "./EditInsuranceCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports